import { BaseEntity } from "@mp/common/entities/base.entity";
import { UserModel } from "@m481/mp-sdk-ng";

export interface UserEntity extends BaseEntity {
    email: string;
    password: string;
    verified: boolean;
    name: string;
    username: string;
    teamsAdmin: Array<string>;
    teamsMember: Array<string>;
    avatarUrl?: string;
    disabledInView?: boolean; //not in model
}

export class UserEntityHelper {
    public static fromModel(userModel: UserModel): UserEntity {
        return {
            id: userModel.id,
            email: userModel.email,
            password: userModel.password,
            verified: userModel.verified,
            name: userModel.name,
            username: userModel.username,
            teamsAdmin: userModel.teamsAdmin || [],
            teamsMember: userModel.teamsMember || [],
            avatarUrl: userModel.avatar,
            isEnabled: userModel?.isEnabled ?? true
        };
    }

    public static toModel(userEntity: UserEntity): UserModel {
        return {
            id: userEntity.id,
            email: userEntity.email,
            username: userEntity.username,
            password: userEntity.password,
            verified: userEntity.verified,
            name: userEntity.name,
            teamsAdmin: userEntity.teamsAdmin,
            teamsMember: userEntity.teamsMember,
            avatarUrl: userEntity.avatarUrl,
            isEnabled: userEntity?.isEnabled ?? true
        };
    }
}
